// Need to use the React-specific entry point to import createApi
import { BaseQueryFn, createApi, EndpointDefinitions, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../helpers';
import { SearchAddress, SearchAddressResult, SearchAddressResults } from '../types/Map';

const methods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
} as const;
const tags = {
  openStreetMap: 'openStreetMap',
}

// Define a service using a base URL and expected endpoints
export const apiMap = createApi({
  reducerPath: 'apiMap',
  baseQuery: (args, ...moreArgs) => {
    const temp = fetchBaseQuery({
      baseUrl: 'https://nominatim.openstreetmap.org',
      prepareHeaders: (headers, { getState }) => {
        headers.set('Content-Type', 'application/json');
        headers.set('Accept', 'application/json');
        return headers;
      },
    });
    return temp(args, ...moreArgs);
  },
  tagTypes: Object.values(tags),
  endpoints: (builder) => ({
    searchAddress: builder.query<SearchAddressResult[], SearchAddress>({
      query: ({ q, street, city, county, state, country, postalcode }) => {
        let url = "/search.php?format=jsonv2";
        if (q) { url += `&q=${q}`; }
        if (street) { url += `&street=${street}`; }
        if (city) { url += `&city=${city}`; }
        if (county) { url += `&county=${county}`; }
        if (state) { url += `&state=${state}`; }
        if (country) { url += `&country=${country}`; }
        if (postalcode) { url += `&postalcode=${postalcode}`; }
        return {
          url,
          method: methods.GET,
        };
      }
    }),
  }),
  // endpoints: (builder): EndpointDefinitions  => ({} as EndpointDefinitions),
});

// Export auto-generated hooks for usage in functional components based on the defined endpoints
export const {
  useSearchAddressQuery,
  useLazySearchAddressQuery,
} = apiMap;

